export const CATEGORIES = ["Tous", "Sandwichs", "Assiettes", "Menu Enfant"];

const DISH = "/assets/dishes";

export const MENU_ITEMS = [
    // SANDWICHS
    {
        id: "cheddar-fondu",
        category: "Sandwichs",
        name: "Cheddar Fondu",
        description: "Viande braisée noyée sous le cheddar fondu, un délice coulant.",
        price: "9,80 €",
        badges: [],
        image: `${DISH}/sandwich-cheddar-fondu.jpg`,
    },
    {
        id: "incroyable-steak",
        category: "Sandwichs",
        name: "Incroyable Steak",
        description: "Steak grillé à la braise dans notre pain artisanal, sauce au choix.",
        price: "12,80 €",
        badges: [],
        image: `${DISH}/incroyable-steak.jpg`,
    },
    {
        id: "petit-veau-feta",
        category: "Sandwichs",
        name: "Petit Veau (avec féta)",
        description: "Le sandwich signature de la maison, couronné de fêta crémeuse.",
        price: "12,80 €",
        badges: ["Signature"],
        image: `${DISH}/petit-veau-feta.jpg`,
    },
    {
        id: "sandwich-bavette",
        category: "Sandwichs",
        name: "Sandwich Bavette",
        description: "Bavette de bœuf saisie au feu de bois, frites et sauce maison.",
        price: "12,80 €",
        badges: ["À la Braise"],
        image: `${DISH}/sandwich-bavette.jpg`,
    },
    {
        id: "merguez-kebab",
        category: "Sandwichs",
        name: "Merguez + Kebab",
        description: "Merguez grillée à la braise et kebab, le duo qui cartonne.",
        price: "11,80 €",
        badges: [],
        image: `${DISH}/fantastique-merguez-kebab.jpg`,
    },
    {
        id: "sandwich-merguez",
        category: "Sandwichs",
        name: "Sandwich Merguez",
        description: "Merguez grillée à la braise, crudités, sauce maison, pain artisanal.",
        price: "9,80 €",
        badges: ["À la Braise"],
        image: `${DISH}/sandwich-merguez.jpg`,
    },
    {
        id: "sandwich-kebab",
        category: "Sandwichs",
        name: "Sandwich Kebab",
        description: "Viande kebab cuite à la braise, crudités fraîches, sauce maison.",
        price: "9,80 €",
        badges: ["Best-Seller"],
        image: `${DISH}/sandwich-kebab.jpg`,
    },
    {
        id: "chicken-jaune",
        category: "Sandwichs",
        name: "Chicken Jaune",
        description: "Poulet mariné à la recette jaune de la maison, grillé à la braise.",
        price: "10,80 €",
        badges: ["Fait Maison"],
        image: `${DISH}/sandwich-chicken-jaune.jpg`,
    },
    // ASSIETTES
    {
        id: "assiette-bavette",
        category: "Assiettes",
        name: "Assiette Bavette",
        description: "Salade mixte, riz, frites et pain — bavette saisie au feu de bois.",
        price: "12,80 €",
        badges: ["À la Braise"],
        image: `${DISH}/assiette-bavette.jpg`,
    },
    {
        id: "assiette-petit-veau",
        category: "Assiettes",
        name: "Assiette Petit Veau",
        description: "L'assiette signature de la maison, généreuse et braisée au feu de bois.",
        price: "12,80 €",
        badges: ["Signature"],
        image: `${DISH}/assiette-petit-veau.jpg`,
    },
    {
        id: "assiette-steak",
        category: "Assiettes",
        name: "Assiette Steak",
        description: "Salade mixte, riz, frites et pain — steak grillé à la braise.",
        price: "12,90 €",
        badges: [],
        image: `${DISH}/assiette-steak.jpg`,
    },
    {
        id: "assiette-merguez",
        category: "Assiettes",
        name: "Assiette Merguez",
        description: "Salade mixte, riz, frites et pain — merguez grillée à la braise.",
        price: "12,90 €",
        badges: [],
        image: `${DISH}/assiette-merguez.jpg`,
    },
    // MENU ENFANT
    {
        id: "enfant-burger",
        category: "Menu Enfant",
        name: "Menu Enfant (Hamburger)",
        description: "Le menu des petits gourmands : hamburger, frites et Capri-Sun.",
        price: "6,50 €",
        badges: ["Halal"],
        image: `${DISH}/enfant-burger.jpg`,
    },
    {
        id: "enfant-nuggets",
        category: "Menu Enfant",
        name: "Nuggets + Frites + Capri-Sun",
        description: "Nuggets croustillants, frites et Capri-Sun pour les enfants.",
        price: "6,50 €",
        badges: ["Halal"],
        image: `${DISH}/enfant-nuggets.jpg`,
    },
];
